/**
 * Capacitor platform detection.
 *
 * Centralised helper so every mobile feature gracefully no-ops on the web
 * bundle. On native builds the Capacitor runtime is injected — we lazy-load
 * the core module so the web bundle doesn't have to ship it.
 *
 * Usage:
 *   import { isNative, getPlatform } from "@/mobile/platform";
 *   if (await isNative()) { ... }
 */
let _capacitorCache = null;

async function _loadCapacitor() {
  if (_capacitorCache !== null) return _capacitorCache;
  try {
    // Dynamic import; bundled only when present (Capacitor injects it).
    const mod = await import("@capacitor/core");
    _capacitorCache = mod?.Capacitor || null;
  } catch {
    _capacitorCache = null;
  }
  return _capacitorCache;
}

export async function isNative() {
  const Cap = await _loadCapacitor();
  return !!(Cap && Cap.isNativePlatform && Cap.isNativePlatform());
}

export async function getPlatform() {
  const Cap = await _loadCapacitor();
  return Cap?.getPlatform?.() || "web";
}
